// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"260":"abee4ef7","668":"79fc46b3","762":"47e2cbcc"}[chunkId] + ".js";
};